// src/components/Dashboard.jsx

const MENU_ADMIN_GURU = [
  {
    key: 'siswa',
    icon: '📚',
    title: 'Manajemen Siswa',
    desc: 'Tambah, edit, hapus, dan pindahkan kelas siswa.',
  },
  {
    key: 'kehadiran',
    icon: '📝',
    title: 'Catat Kehadiran',
    desc: 'Pilih tanggal, kelas, dan sesi untuk mencatat kehadiran siswa.',
  },
  {
    key: 'laporan',
    icon: '📊',
    title: 'Laporan Kehadiran',
    desc: 'Lihat laporan kehadiran harian, bulanan, atau per siswa.',
  },
  {
    key: 'jurnal',
    icon: '📔',
    title: 'Jurnal Pembelajaran',
    desc: 'Catat tujuan pembelajaran & materi tiap pertemuan, kehadiran otomatis dari absen.',
  },
  {
    key: 'backup',
    icon: '💾',
    title: 'Backup Data',
    desc: 'Cadangkan seluruh data ke file Excel di Google Drive, otomatis atau manual.',
  },
];

const MENU_ADMIN_ONLY = {
  key: 'pengguna',
  icon: '👥',
  title: 'Manajemen Pengguna',
  desc: 'Kelola akun pengguna dan peran (Administrator/Guru).',
};

const MENU_SISWA = {
  key: 'kehadiran-saya',
  icon: '📊',
  title: 'Kehadiran Kelas Saya',
  desc: 'Lihat rekap kehadiranmu di kelas.',
};

function Card({ icon, title, desc, onClick }) {
  return (
    <button
      onClick={onClick}
      className="bg-white rounded-2xl shadow-md hover:shadow-lg p-6 text-center transition-shadow w-full"
    >
      <div className="text-4xl mb-3">{icon}</div>
      <h3 className="font-bold text-lg text-gray-800 mb-1">{title}</h3>
      <p className="text-sm text-gray-500">{desc}</p>
    </button>
  );
}

export default function Dashboard({ user, onNavigate, onLogout }) {
  const menus =
    user.role === 'Siswa'
      ? [MENU_SISWA]
      : user.role === 'Admin'
      ? [...MENU_ADMIN_GURU, MENU_ADMIN_ONLY]
      : MENU_ADMIN_GURU; // Guru

  return (
    <div className="min-h-screen bg-blue-50">
      <header className="bg-white shadow-sm">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-4 flex flex-wrap items-center justify-between gap-3">
          <h1 className="text-xl sm:text-2xl font-bold text-gray-800">Aplikasi Kehadiran Siswa</h1>
          <div className="flex items-center gap-3">
            <span className="text-sm text-gray-600">
              Selamat datang, <strong>{user.nama}</strong>{' '}
              <span className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full uppercase">
                {user.role}
              </span>
            </span>
            <button
              onClick={onLogout}
              className="bg-red-500 hover:bg-red-600 text-white text-sm font-medium px-4 py-2 rounded-lg transition"
            >
              Logout
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-4 sm:px-6 py-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {menus.map((m) => (
            <Card key={m.key} icon={m.icon} title={m.title} desc={m.desc} onClick={() => onNavigate(m.key)} />
          ))}
        </div>
      </main>
    </div>
  );
}
